import { isNil, isEmpty, size, isFunction } from 'lodash';

// define a mixin object
export default {

  data() {
    return {
      systemStatus: 'ok',
    };
  },

  updated: function () {
  },

  computed: {
  },

  created: function () {
    this.updateStatus();
  },

  methods: {
    updateStatus() {
      try {
        let statusPageId = '12971';
        switch (process.env.WHITE_LABEL_KEY) {
          case 'hotelmeister':
            statusPageId = '120821';
            break;
          default:
            statusPageId = '12971';
            break;
        }

        fetch(`https://sjioxyois2.execute-api.eu-central-1.amazonaws.com/production/status-pages/${statusPageId}`)
          .then(response => response.json())
          .then((data) => {
            switch (data.data.attributes.aggregate_state) {
              case 'operational':
                this.systemStatus = 'ok';
                break;
              default:
                this.systemStatus = 'warn';
                break;
            }
          });
        // eslint-disable-next-line no-empty
      } catch (ignore) {
        console.error(ignore);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/StatusMixin.js